export type UserRole = 'admin' | 'vendedor' | 'revenda' | 'cliente' | 'producao' | 'clientes_plus';

export interface PermissionColors {
  primary: string;
  hover: string;
  text: string;
}

export const roleColors: Record<UserRole, PermissionColors> = {
  admin: {
    primary: 'bg-gold-400',
    hover: 'hover:bg-gold-500',
    text: 'text-gold-400'
  },
  vendedor: {
    primary: 'bg-blue-600',
    hover: 'hover:bg-blue-700',
    text: 'text-blue-400'
  },
  revenda: {
    primary: 'bg-purple-600',
    hover: 'hover:bg-purple-700',
    text: 'text-purple-400'
  },
  cliente: {
    primary: 'bg-orange-500',
    hover: 'hover:bg-orange-600',
    text: 'text-orange-400'
  },
  producao: {
    primary: 'bg-red-600',
    hover: 'hover:bg-red-700',
    text: 'text-red-400'
  },
  clientes_plus: {
    primary: 'bg-green-600',
    hover: 'hover:bg-green-700',
    text: 'text-green-400'
  }
};

export interface Permission {
  // null quando o role ainda não foi resolvido (carregando) ou é inválido
  role: UserRole | null;
  features: {
    canValidate: boolean;
    canSave: boolean;
    canExport: boolean;
    canExportLayoutPng: boolean;
    canViewReports: boolean;
    canAccessTools: boolean;
    canAccessCalendar: boolean;
    showSimplifiedInterface: boolean;
  };
}
